import { Component, Renderer2 } from '@angular/core';
import { RouterLink, RouterOutlet, Router, NavigationEnd } from '@angular/router';
import { HeaderComponent} from './shared/components/header/header.component';
import { FooterComponent} from './shared/components/footer/footer.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, RouterLink, HeaderComponent, FooterComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {

  bg: string = '';

  constructor(private router: Router, private renderer : Renderer2) {}

  ngOnInit(): void{

    this.router.events.subscribe(event=>{
      if (event instanceof NavigationEnd) {
        if (event.urlAfterRedirects == '/' || event.urlAfterRedirects == '/home'){
          this.renderer.setStyle(document.body, 'background-color', '#FEFAF2');
        } else if( this.router.url.startsWith('/exam') || this.router.url.startsWith('/question/')){
          this.renderer.setStyle(document.body, 'background-color', 'white');
        }
        else{
          this.renderer.setStyle(document.body, 'background-color', 'white');
        }
      }
    });
  }
}
